import { m } from 'framer-motion';
import { useState, useRef, useEffect } from 'react';
import useResponsive from "src/hooks/useResponsive";
// @mui
import { alpha, useTheme } from '@mui/material/styles';
import { Box, Card, Paper, Button, Typography, CardContent } from '@mui/material';
// utils
import * as React from "react";
import {useNavigate} from "react-router-dom";
import { bgGradient } from '../../../../utils/cssStyles';
// components
import Image from '../../../../components/image';
import { MotionContainer, varFade } from '../../../../components/animate';
import Carousel, { CarouselArrowIndex } from '../../../../components/carousel';

import imageCarousel1 from '../img/Psicologos.png'
import imageCarousel2 from '../img/Anjos.png'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import HistoricoAcolhimentoPrimeiroAcesso
  from "../../../../components/historico-acolhimento/HistoricoAcolhimentoPrimeiroAcesso";
import {PATH_DASHBOARD} from "../../../../routes/paths";
// ----------------------------------------------------------------------

export default function BannerDashboardFirst() {
  const theme = useTheme();

  const isDesktop = useResponsive('up', 'lg');

  const arraySliders = [
    {
      id: 1,
      image: imageCarousel1,
      title: 'Encontre um Psicólogo',
      description: 'PRECISA DE ATENDIMENTO PROFISSIONAL',
      link:'',
      botao:'Ver Psicólogos',
      tipo:'psi'
    },
    {
      id: 2,
      image: imageCarousel2,
      title: 'Encontre um Anjo',
      description: 'PRECISA DESABAFAR AGORA?',
      link:'',
      botao:'Ver Anjos',
      tipo:'anjo'
    }
  ];

  const carouselRef = useRef<Carousel | null>(null);

  const [currentIndex, setCurrentIndex] = useState(theme.direction === 'rtl' ? arraySliders.length - 1 : 0);

  const carouselSettings = {
    speed: 1100,
    dots: true,
    arrows: false,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: Boolean(theme.direction === 'rtl'),
    beforeChange: (current: number, next: number) => setCurrentIndex(next),
  };

  useEffect(() => {
    const disableScroll = (e: TouchEvent) => {
      if (Math.abs(e.touches[0].clientX - startX) > 10) {
        e.preventDefault();
      }
    };

    let startX = 0;

    const carouselWrapperElement = document.getElementById('carousel-wrapper');

    if (carouselWrapperElement) {
      carouselWrapperElement.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });

      carouselWrapperElement.addEventListener('touchmove', disableScroll, { passive: false });
    }

    return () => {
      if (carouselWrapperElement) {
        carouselWrapperElement.removeEventListener('touchstart', (e) => {
          startX = e.touches[0].clientX;
        });

        carouselWrapperElement.removeEventListener('touchmove', disableScroll);
      }
    };
  }, []);

  const handlePrev = () => {
    carouselRef.current?.slickPrev();
  };

  const handleNext = () => {
    carouselRef.current?.slickNext();
  };

  return (
    <Card sx={{ marginLeft:{ xs:1, sm: 2, md: 3 }}}>
      <div id="carousel-wrapper" style={{ overflow: 'hidden' }}>
        <Carousel ref={carouselRef} {...carouselSettings}>
          {arraySliders.map((item, index) => (
            <Carousel2Item key={item.id} item={item} isActive={index === currentIndex} />
          ))}
        </Carousel>
      </div>
    </Card>
  );
}

// ----------------------------------------------------------------------

type CarouselItemProps = {
  item: {
    title: string;
    description: string;
    image: string;
    link: string;
    botao: string;
    tipo: string;
  };
  isActive: boolean;
};

function Carousel2Item({ item, isActive }: CarouselItemProps) {
  const { image, title } = item;

  const navigate = useNavigate();
  const irparaanjos = () =>{
    navigate(PATH_DASHBOARD.atendentes);
  }

  const irparapsi = () =>{
    navigate(PATH_DASHBOARD.psicologos);
  }



  return (
    <Paper sx={{ position: 'relative' }}>
      <img src={image} alt="" width="100%"/>
    <div className="destivar">{image}</div>
      <Box
        sx={{
          top: 0,
          width: 1,
          height: 1,
          position: 'absolute',
        }}
      />

      <CardContent
          component={MotionContainer}
          animate={isActive}
          action
          sx={{
            bottom: { xs: 30, sm: 50, md: 100 },
            left:30,
            width: 1,
            maxWidth: 720,
            textAlign: 'left',
            position: 'absolute',
            color: 'common.white',
          }}
      >
        <m.div variants={varFade().in}>
          <Typography variant="body2" gutterBottom>
            {item.description}
          </Typography>
        </m.div>
        <m.div variants={varFade().in}>
          <Typography variant="h3" gutterBottom>
            {item.title}
          </Typography>
        </m.div>
        <m.div variants={varFade().in}>
          {

            item.tipo === 'anjo' ? (
                <Button variant="contained" onClick={irparaanjos} color="primary">{item.botao}</Button>
                ) : (
                <Button variant="contained" onClick={irparapsi} className="chipTipoAtendentePsicologo" color="primary">{item.botao}</Button>
            )
          }

        </m.div>


      </CardContent>
    </Paper>
  );
}
